import styles from './Trends.module.css'
export function InspotLight(){
    return(
        <section className="section blogSection bgGray">
        <div className="container">
            <h2 className="heading  font26 text222 f500 mb12 textUpper">IN SPOTLIGHT</h2>
            <p className="subHeading  mb46 font16">Your personal aesthetic coupled with our visual inspiration is a mood board made in heaven!</p>
            <div className={styles.blogTaile}>
                <div className={styles.blogLeft}>
                    <figure><img src="/assets/images/blogleftBig.jpg" className="imgFluid"/></figure>
                    <div className={styles.blogLeftBody}>
                        <span className="blogTag mb10 font12 textpink dIlineBlock">LIVING ROOM</span>
                        <h3 className="f500 font16 mb10 text222 textEllpise fontSM14">Creative Wall Partition Designs for the Modern Home</h3>
                        <p className="font14 text666  lineClamp">A living room partition wall helps you separate the reception area from the other rooms without completely cutting ...</p>
                    </div>
                </div>
                <div className={styles.blogRightList}>
                    <div className={styles.blogSmList}>
                        <figure><img src="/assets/images/Inspotlightkit1.png" className="imgFluid"/></figure>
                        <div className={styles.rightBlogDetails}>
                            <span className="tag bgGray textpink">MODULAR KITCHEN</span>
                            <p className="font16 text222 f500 lineClamp">6 Kitchen Furniture Designs for a
                                More Functional and Efficient
                                Kitchen</p>
                            <span className="date font12 text666">May 12, 2022</span>
                        </div>
                    </div>
                    <div className={styles.blogSmList}>
                        <figure><img src="/assets/images/Inspotlightkit2.png" className="imgFluid"/></figure>
                        <div className={styles.rightBlogDetails}>
                            <span className="tag bgGray textpink">MODULAR KITCHEN</span>
                            <p className="font16 text222 f500 lineClamp">Which Cabinet Handles Are Perfect
                                for You? (Profile Handles for
                                Kitchens, and More)</p>
                            <span className="date font12 text666">May 14, 2022</span>
                        </div>
                    </div>
                    <div className={styles.blogSmList}>
                        <figure><img src="/assets/images/Inspotlightkit3.png" className="imgFluid"/></figure>
                        <div className={styles.rightBlogDetails}>
                            <span className="tag bgGray textpink">MODULAR KITCHEN</span>
                            <p className="font16 text222 f500 lineClamp">20+ L-Shaped Kitchen Design Ideas That
                                Will Make You Want an L-Shaped Kitchen
                                Too!</p>
                            <span className="date font12 text666">May 16, 2022</span>
                        </div>
                    </div>
                    
                </div>


                <div className={styles.blogCenter}>
                    <div className={`${styles.blogMidTile} gridSpan2`}>
                        <div className={`${styles.midBlogtext} textfff`}><span className="bgGray textpink">BALCONY</span> <p className="lineClamp textfff font16">14 Balcony Tiles Designs That Will Floor You</p></div>
                        <img src="/assets/images/Inspotbal1.png" className="imgFluid"/>
                    </div>
                    <div className={`${styles.blogMidTile} ${styles.midFix}`}>
                        <div className={styles.midBlogtext}><span className="bgGray textpink">BALCONY</span> <p className="lineClamp textfff font16">10+ Modern Balcony Grill Design Ideas ...</p></div>
                        <img src="/assets/images/Inspotbal2.png" className="imgFluid"/>
                    </div>
                    <div className={`${styles.blogMidTile} ${styles.midFix}`}>
                        <div className={styles.midBlogtext}><span className="bgGray textpink">BALCONY</span> <p className="lineClamp textfff font16">25+ Balcony Design Ideas — The Top ...</p></div>
                        <img src="/assets/images/Inspotbal3.png" className="imgFluid"/>
                    </div>
                    
                </div>
        
               
            </div>
        </div>
    </section>
    )
}